import { registerComponent } from '@gig/magic-common';
import DateComponent from './date.vue.js';

var Date = registerComponent(DateComponent);

export { Date };
